//import Components
import {createContext, useContext, useState} from "react";

//----------------[This is code for global variables across all pages]---------------------//

const defaultData = {

}

const AppContext = createContext(undefined);


export function AppDataProvider ({...props}) {
    const [appData, setAppData] = useState(defaultData);
    return (
        <>
            <AppContext.Provider value={[appData, setAppData]}>
                {props.children}
            </AppContext.Provider>
        </>
    )
}

export function useAppData() {
    const context = useContext(AppContext);

    if (!context) {
        throw new Error("useAppState must be within AppStateProvider");
    }
    return context;
}